
<app-user-layout>

    <div class="grid grid-cols-1 text-left text-[#414141] ">
        <div class="grid-col" *ngIf="appName?.toUpperCase()=='ODOO'">
            <app-native-odoo 
                [appVersion]="version"
                [appPage]="pageName">
            </app-native-odoo>
        </div>

        <div class="grid-col" *ngIf="appName?.toUpperCase()=='DPR_106'">
            <app-native-dpr
                [appVersion]="version"
                [appPage]="pageName">
            </app-native-dpr>
        </div>
    </div>

</app-user-layout>
